// extracted by extract-css-chunks-webpack-plugin
module.exports = {"imageProdBlock":"NNSV-","imageSlider":"qWa0T"};